import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ajaxCall } from './axios'
import { showMessage } from './message'
// eslint-disable-next-line import/no-cycle
import { reloadPageContent } from './app'

const initialState = {
  form: null,
  goTo: null,
  scrollUp: null,
  errors: {},
}

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateForm: (state, action) => {
      state.form = action.payload
    },
    resetForm: (state) => {
      state.form = null
    },
    formSaved: (state, action) => {
      state.goTo = action.payload.goTo || action.payload.data.goTo
      state.reload = action.payload.reload || action.payload.data.reload
      state.scrollUp = action.payload.scrollUp || action.payload.data.scrollUp
    },
    resetGoTo: (state) => {
      state.goTo = null
    },
    resetScrollUp: (state) => {
      state.scrollUp = null
    },
    resetReload: (state) => {
      state.reload = null
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    },
  },
})

export const {
  updateForm,
  resetForm,
  formSaved,
  resetGoTo,
  updateErrors,
  resetScrollUp,
  resetReload,
} = formSlice.actions

export const saveForm = createAsyncThunk('form/save', async (data, thunkAPI) => {
  const { formValues, asNew, params, id, uid, url, method, extra } = data

  const router = thunkAPI.router

  const formContent = {
    fields: formValues,
    id,
    uid,
  }

  if (asNew) {
    formContent.id = null

    formContent.uid = null
  }

  if (params.temporarySave) {
    params.isDraft = 1
  }

  let currentUrl = new URL(window.location.href)

  currentUrl = currentUrl.pathname

  currentUrl = currentUrl.substring(4, currentUrl.length)

  thunkAPI.dispatch(updateErrors({}))

  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url,
        method: method || 'post',
        data: { ...formContent, ...extra },
        params,
      },
      success: (res) => {
        const content = res.data || {}

        let tempParams = { ...params }

        if (res.data?.goTo) {
          tempParams = { ...params, goTo: res.data.goTo }
        }

        if (res.data?.data?.reloadPageContent) {
          const prefix = res.data?.data?.prefix
          thunkAPI.dispatch(reloadPageContent(`${prefix}${currentUrl}/page`))
        }

        if (res.data?.data?.scrollUp) {
          window.scrollTo(0, 0)
        }

        if(res.data?.data.reload){
          router.reload()
        }

        if (res.status === 200) {
          thunkAPI.dispatch(formSaved({ data: content.data, ...tempParams }))
        }

        if (!params.temporarySave && res.status === 200 && res.data.message) {
          setTimeout(() => {
            thunkAPI.dispatch(
              showMessage({
                message: res.data.message,
                type: 'success',
                autoHide: true,
              })
            )
          }, 200)
        }
      },
      error: (res) => {
        if (res.status === 400) {
          thunkAPI.dispatch(updateErrors(res.data))
        }

        if (res.data?.reloadPageContent) {
          const prefix = res.data?.prefix
          thunkAPI.dispatch(reloadPageContent(`${prefix}${currentUrl}/page`))
        }

        if (res.data?.scrollUp) {
          window.scrollTo(0, 0)
        }

        if (res.data?.goTo){
          const goTo = res.data.goTo
          router.push(window.appConfig.appPrefix + goTo)
        }

        if(res.data?.reload){
          router.reload()
        }

      },
      activeLoading: false,
    })
  )
})

export const getFormData = createAsyncThunk('form/getFormData', async (data, thunkAPI) => {
  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: data.url,
        method: 'get',
        params: data.params,
      },
      success: (res) => {
        if (typeof data.callback === 'function') {
          data.callback(res.data)
        }
      },
    })
  )
})

export const getForm = createAsyncThunk('form/getForm', async (data, thunkAPI) => {
  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: data.url,
        method: 'get',
        params: data.params,
      },
      success: (res) => {
        thunkAPI.dispatch(updateForm(res.data))
      },
    })
  )
})

export default formSlice.reducer
